export default {
  title: '生产管理',
  productionPlan: '生产计划',
};
